/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum UserIdentityOrigin {
    Unknown = 'Unknown',
    Federated = 'Federated',
    Local = 'Local'
}


export function instanceOfUserIdentityOrigin(value: any): boolean {
    for (const key in UserIdentityOrigin) {
        if (Object.prototype.hasOwnProperty.call(UserIdentityOrigin, key)) {
            if (UserIdentityOrigin[key as keyof typeof UserIdentityOrigin] === value) {
                return true;
            }
        }
    }
    return false;
}

export function UserIdentityOriginFromJSON(json: any): UserIdentityOrigin {
    return UserIdentityOriginFromJSONTyped(json, false);
}

export function UserIdentityOriginFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserIdentityOrigin {
    return json as UserIdentityOrigin;
}

export function UserIdentityOriginToJSON(value?: UserIdentityOrigin | null): any {
    return value as any;
}

export function UserIdentityOriginToJSONTyped(value: any, ignoreDiscriminator: boolean): UserIdentityOrigin {
    return value as UserIdentityOrigin;
}

